import React from 'react'
import { Navbar } from '../components/Navbar'
// import herobackground from '../assets/herobackground.jpg';
import women_empowerment from '../assets/women_empowerment.jpg'
import { FaHome } from "react-icons/fa";
import OurServices from '../components/OurServices';
import Achievement from '../components/Achievement';
import Footer from '../components/Footer';


const Services = () => {
    return (
        <>
            <div
                style={{
                    background: `url(${women_empowerment}) no-repeat center center / cover`,
                    height: "70vh",
                    position: "relative",
                }}
            >
                <Navbar />
                <section
                    className="d-flex flex-column flex-lg-row align-items-center justify-content-between container-lg"
                    style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                    }}
                >
                    <div style={{ position: "relative", zIndex: 2, backgroundColor: "rgba(0,0,0,0.5)", padding: "20px 30px", borderRadius: "10px" }}>
                        <p style={{ fontSize: "1rem", letterSpacing: "1px", marginBottom: "10px" }}>
                            <FaHome className="text-info" /> <span style={{ color: "#00bfff" }}>Home</span> &gt; OUR SERVICES
                        </p>
                        <h1 style={{ fontSize: "3rem", fontWeight: 700, margin: 0 }}>Our Services</h1>
                    </div>
                </section>

                <OurServices />
                <Achievement />
                <br />
                <br />
                <Footer />
            </div>
        </>
    )
}

export default Services